<template>
  <div class="list">
    <ul class="list-items">
      <li v-for="item in items" :key="item[keyField]" :class="{ 'list-item': true }">
        <a href="#" @click.prevent="selectItem(item)">
          <div :class="{ info: true, [item.status.toLowerCase()]: item.status }">
            <div class="col">
              <slot name="icon" v-bind:item="item"></slot>
            </div>
            <div class="col">
              <span class="title">
                <slot name="title" v-bind:item="item"></slot>
              </span>
              <span class="description">
                <slot name="description" v-bind:item="item"></slot>
              </span>
            </div>
          </div>
          <next-arrow-icon-neutral />
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import NextArrowIconNeutral from "@/components/_base/NextArrowIconNeutral.vue"

export default {
  name: "AlertItemList",
  props: {
    items: {
      type: Array,
      required: true
    },
    keyField: {
      type: String,
      required: false,
      default: "key"
    }
  },
  components: {
    NextArrowIconNeutral
  },
  methods: {
    selectItem(item) {
      this.$emit("item-selected", item)
    }
  }
}
</script>

<style scoped>
.info.pending .title {
  font-weight: bold;
}

.info.done .title,
.info.canceled .title {
  font-weight: 400;
}

.info .title {
  font-family: Roboto;
  font-size: 16px;
  line-height: 20px;
  color: var(--color-neutral-90);
}

.info .description {
  font-family: Roboto;
  font-size: 14px;
  line-height: 18px;
  color: var(--color-neutral-50);
}

.list .list-items {
  list-style: none;
  padding: 0;
  margin: 0;
  padding-top: 10px;
  padding-bottom: 30px;
}

.list-item a {
  color: grey;
  text-decoration: none;

  display: flex;
  justify-content: space-between;
  align-items: center;
}

.list-item .info {
  display: flex;
  flex-direction: unset;
}

.list-item .info .col {
  display: flex;
  flex-direction: column;
}

.list-item {
  color: grey;
  text-decoration: none;
}

.list-item {
  border-top: 1px solid #e0e0e0;
  padding: 10px 5px;
}

.list-item:hover {
  background-color: #fafafa;
}

.list-item:last-child {
  border-bottom: 1px solid #e0e0e0;
}

.icon.icon-svg {
  width: 28px;
  padding-right: 8px;
  padding-top: 5px;
  height: auto;
}
</style>
